import { render, staticRenderFns } from "./DualAxisChart.vue?vue&type=template&id=61dc04a0"
import script from "./DualAxisChart.vue?vue&type=script&lang=js"
export * from "./DualAxisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports